export const OutboundCallIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect
      x="28"
      y="28"
      width="28"
      height="28"
      rx="14"
      transform="rotate(180 28 28)"
      fill="#51C8FF"
    />
    <path
      d="M20.417 14H7.58366"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.8335 19.25L7.5835 14L12.8335 8.75"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
